import desktopFooter from "./Footer.desktop";
import mobileFooter from "./Footer.mobile";

let Footer = null;

// #!if iOS === true
// Footer = mobileFooter;
// #!else
Footer = desktopFooter;
// #!endif

export default Footer;
